export default __webpack_public_path__ + "static/media/logoemer.71cf8850.png";